import { useState } from "react";
import { Link } from "react-router-dom";

const NEWSLETTER_URL = "https://readdy.ai/api/form/d7efj5bfimgqccpma8dg";

export default function Footer() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      const body = new URLSearchParams({ email });
      await fetch(NEWSLETTER_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      setSubmitted(true);
      setEmail("");
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#0D2B2B] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="https://static.readdy.ai/image/64d067dc58cbae89e71ec40faad2636e/deaaf3708287f522a170a22cd3f29889.jpeg"
                alt="Mind Odyssey"
                className="w-10 h-10 rounded-full object-cover"
              />
              <span className="font-bold text-xl" style={{ fontFamily: "'Playfair Display', serif" }}>
                Mind Odyssey
              </span>
            </div>
            <p className="text-white/60 text-sm leading-relaxed mb-6 max-w-xs">
              Empowering adults to transform their mindset, accelerate their careers, and build lives of purpose and abundance.
            </p>
            {/* Newsletter */}
            <form
              data-readdy-form
              id="newsletter-form"
              onSubmit={handleSubscribe}
              className="flex gap-2"
            >
              {submitted ? (
                <p className="text-teal-400 text-sm font-medium">Thanks for subscribing!</p>
              ) : (
                <>
                  <input
                    type="email"
                    name="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Your email address"
                    className="flex-1 bg-white/10 border border-white/20 rounded-full px-4 py-2 text-sm text-white placeholder-white/40 focus:outline-none focus:border-teal-400"
                    required
                  />
                  <button
                    type="submit"
                    disabled={submitting}
                    className="w-10 h-10 flex items-center justify-center bg-teal-500 rounded-full hover:bg-teal-400 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-send-plane-line text-white" />
                  </button>
                </>
              )}
            </form>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">Platform</h4>
            <ul className="space-y-3">
              {[
                { label: "Home", path: "/" },
                { label: "Programs", path: "/programs" },
                { label: "Community", path: "/community" },
                { label: "Dashboard", path: "/dashboard" },
              ].map((l) => (
                <li key={l.path}>
                  <Link to={l.path} className="text-white/50 text-sm hover:text-teal-400 transition-colors cursor-pointer">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">Coaching</h4>
            <ul className="space-y-3">
              {["Mindset", "Life Coaching", "Career", "Corporate", "Wellness"].map((c) => (
                <li key={c}>
                  <Link to="/programs" className="text-white/50 text-sm hover:text-teal-400 transition-colors cursor-pointer">
                    {c}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold text-sm mb-4 text-white/90">Company</h4>
            <ul className="space-y-3">
              {["About Us", "Become a Coach", "Monetize", "Privacy Policy", "Terms of Service"].map((c) => (
                <li key={c}>
                  <a href="#" className="text-white/50 text-sm hover:text-teal-400 transition-colors cursor-pointer">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">© 2026 Mind Odyssey. All rights reserved.</p>
          <div className="flex items-center gap-3">
            {["ri-instagram-line", "ri-linkedin-box-line", "ri-twitter-x-line", "ri-youtube-line"].map((icon) => (
              <a
                key={icon}
                href="#"
                className="w-8 h-8 flex items-center justify-center border border-white/20 rounded-lg hover:border-teal-400 hover:text-teal-400 transition-colors cursor-pointer text-white/60"
              >
                <i className={`${icon} text-sm`} />
              </a>
            ))}
          </div>
          <p className="text-white/40 text-xs">
            <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer" rel="nofollow">Privacy</a>
            {" · "}
            <a href="#" className="hover:text-teal-400 transition-colors cursor-pointer" rel="nofollow">Terms</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
